import type { TwiageCase } from "@/App/types/TwiageCase";
import { isClosedByEms } from "@/Pages/Cases/functions/isClosedByEms";
import { CaseType } from "@/App/types/caseType";

export enum SortBy {
  eta,
  expectedPickupTime,
}

export const sortCases = ({ sortBy }: { sortBy?: SortBy }): ((a: TwiageCase, b: TwiageCase) => number) => {
  switch (sortBy) {
    case SortBy.eta:
      return etaComparator;
    case SortBy.expectedPickupTime:
      return expectedPickUpTimeComparator;
    default:
      return caseNumberComparator;
  }
};

const caseNumberComparator = (a: TwiageCase, b: TwiageCase): number => b.caseNumber - a.caseNumber;

const expectedPickUpTimeComparator = (a: TwiageCase, b: TwiageCase): number => {
  const comparison = (a.ift?.expectedPickupTime ?? "0").localeCompare(b.ift?.expectedPickupTime ?? "0");
  if (comparison === 0) {
    return caseNumberComparator(a, b);
  }
  return comparison;
};

const etaComparator = (a: TwiageCase, b: TwiageCase): number => {
  return artificialEta(a) - artificialEta(b);
};

// To make certain cases to be in certain position for "next arriving" sorting
// this value is used. Supposedly it's higher that any possible ETA value
const maxEta = Number.MAX_SAFE_INTEGER;

const artificialEta = (twCase: TwiageCase): number => {
  return isClosedByEms(twCase)
    ? maxEta
    : twCase.type === CaseType.hospital
      ? maxEta - 1
      : twCase.eta <= 0
        ? maxEta - 2
        : twCase.eta;
};
